enum WeightUnit {
  Pounds = 'Pounds',
  Ounces = 'Ounces',
  Grams = 'Grams',
}

export default WeightUnit
